/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GenericCounterKey } from './GenericCounterKey';
import {
    GenericCounterKeyFromJSON,
    GenericCounterKeyFromJSONTyped,
    GenericCounterKeyToJSON,
    GenericCounterKeyToJSONTyped,
} from './GenericCounterKey';

/**
 * This is a generic collection that will allow an arbitrary key to be set and incremented.
 * @export
 * @interface GenericCounter
 */
export interface GenericCounter {
    /**
     * 
     * @type {string}
     * @memberof GenericCounter
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GenericCounter
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof GenericCounter
     */
    updatedAt: number;
    /**
     * 
     * @type {GenericCounterKey}
     * @memberof GenericCounter
     */
    key: GenericCounterKey;
    /**
     * 
     * @type {string}
     * @memberof GenericCounter
     */
    count: string;
}



/**
 * Check if a given object implements the GenericCounter interface.
 */
export function instanceOfGenericCounter(value: object): value is GenericCounter {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function GenericCounterFromJSON(json: any): GenericCounter {
    return GenericCounterFromJSONTyped(json, false);
}

export function GenericCounterFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenericCounter {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'key': GenericCounterKeyFromJSON(json['key']),
        'count': json['count'],
    };
}

export function GenericCounterToJSON(json: any): GenericCounter {
    return GenericCounterToJSONTyped(json, false);
}

export function GenericCounterToJSONTyped(value?: GenericCounter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'key': GenericCounterKeyToJSON(value['key']),
        'count': value['count'],
    };
}

